<!-- 发货时间 -->
<template>
  <div class="delivery-time">
    <img 
      class="delivery-time__ding"
      :src="require('@@/assets/img/icons/icon_ding.png')" 
    />
    <div class="delivery-time__content">
      <ul class="delivery-time__content__list" :class="{ 'is-fold': isFold }">
        <li 
          class="delivery-time__handle" 
          @click="() => isFold = !isFold"
        >
          <i></i>
          当天<span>18:00</span>后付款，交期顺延<span>1天</span>
          <p>
            <span v-if="isFold">
              已折叠
            </span>
            <i :class="`el-icon-arrow-${isFold ? 'right' : 'down'}`" />
          </p>
        </li>
        <template v-if="!isFold">
          <li>
            <i></i>
            当天<span>21:00</span>后EQ处理完成的订单，交期顺延<span>1天</span>
          </li>
          <li>
            <i></i>
            周日只接单不安排生产，交期同<span>周一</span>下单一致
          </li>
        </template>
      </ul>
    </div>
    
    <div v-if="tips" class="delivery-time__tips">
      <i></i>
      {{ tips }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tips: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isFold: false
    }
  }
}
</script>

<style lang="scss" scoped>
.delivery-time {
  position: relative;
  margin-top: 10px;
  .delivery-time__ding {
    display: block;
    width: 14px;
    position: absolute;
    left: 3px;
    top: -6px;
  }
}

.delivery-time__content {
  padding: 3px 3px;
  border-radius: 3px;
  background-color: #F9F9F9;
  .delivery-time__content__list {
    padding: 3px 0;
    font-size: 12px;
    color: #555555;
    &.is-fold {
      padding: 0;
      >li {
        >span {
          color: #555555;
        }
      }
    }
    >li {
      display: flex;
      align-items: center;
      position: relative;
      list-style: none;
      padding: 0 6px 0 10px;
      height: 22px;
      >i {
        display: block;
        margin-right: 4px;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #999999;
      }
      >span {
        color: #C5792B;
      }
    }
  }
}

li.delivery-time__handle {
  display: flex;
  align-items: center;
  cursor: pointer;
  &:hover {
    >p {
      >i {
        color: #111111;
      }
    }
  }
  >p {
    flex: 1;
    text-align: right;
    >span {
      color: #D0D0D0;
    }
    >i {
      color: #555555;
    }
  }
}

.delivery-time__tips {
  margin-top: 3px;
  padding: 8px 13px;
  font-size: 12px;
  color: #FF4D4F;
  border-radius: 2px;
  background-color: #FEF0F0;
  >i {
    margin-top: -2px;
    margin-right: 1px;
    display: inline-block;
    width: 4px;
    height: 4px;
    vertical-align: middle;
    border-radius: 50%;
    background-color: #FF4D4F;
  }
}

</style>